
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Capacitor } from "@capacitor/core";
import {
  createVuesticEssential,
  VaAlert,
  VaButton,
  VaButtonDropdown,
  VaCard,
  VaCardContent,
  VaCardTitle,
  VaCheckbox,
  VaDataTable,
  VaIcon,
  VaInput,
  VaModal,
  VaSelect,
  VaSeparator,
  VaTab,
  VaTabs,
} from "vuestic-ui";
import "bootstrap/dist/css/bootstrap.min.css";
// Style management
import "./assets/styles/Form.css"
import "./assets/styles/App.css"
import "./assets/styles/Tachograph.css"
import "./assets/styles/Manage.css"
import "./assets/styles/Recap.css"
import 'vuestic-ui/css'

async function requestAppTrackingPermission() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") {
    return;
  }

  try {
    const {
      AppTrackingTransparency,
      AppTrackingTransparencyStatus,
    } = await import("capacitor-app-tracking-transparency");
    const att = new AppTrackingTransparency();
    const status = await att.getStatus();

    if (status === AppTrackingTransparencyStatus.notDetermined) {
      const newStatus = await att.requestPermission();
      console.log("ATT authorization status:", newStatus);
      return;
    }

    console.log("ATT authorization status:", status);
  } catch (error) {
    console.warn("ATT request failed", error);
  }
}

requestAppTrackingPermission();

createApp(App)
  .use(router)
  .use(store)
  .use(
    createVuesticEssential({
      components: {
        VaAlert,
        VaButton,
        VaButtonDropdown,
        VaCard,
        VaCardContent,
        VaCardTitle,
        VaCheckbox,
        VaDataTable,
        VaIcon,
        VaInput,
        VaModal,
        VaSelect,
        VaSeparator,
        VaTab,
        VaTabs,
      },
    })
  )
  .mount("#app");
